import React from 'react';

class ViewWrapper extends React.Component {
  constructor(props) {
    super(props);
    const { screen } = this.props;
    this.state = {
      Screen: screen,
    };
  }

  getComp(screen) {
    const { Api, Attributes, InstanceName } = this.props;
    const comp = React.createElement(Api.module[screen.View], {
      ViewName: screen.View,
      Api: { ...Api, redirect: this.redirect },
      Attributes,
      InstanceName,
      key: new Date().getTime(),
      ...screen.Props,
    });
    return comp;
  }

  currentView() {
    const { Screen } = this.state;
    return Screen.View;
  }

  redirect(view, props = {}) {
    this.setState({ Screen: { View: view, Props: props } });
  }

  render() {
    const { Screen } = this.state;
    const comp = this.getComp(Screen);
    return <div>{comp}</div>;
  }
}

export default ViewWrapper;
